/**
 * Imports the default theme
 *
 */

import './dnb-input-theme-ui.scss'
